import Icon from "@ant-design/icons"
import { ReactComponent as IsraelFlag } from "./israel.svg"

const IsraelFlagIcon = (props: any) => (
  <Icon component={IsraelFlag} {...props} />
)

export default IsraelFlagIcon
